export default __webpack_public_path__ + "static/media/NoEnquiry.2ddb4ff5.svg";